import React, { useEffect, useState, useMemo, useRef } from 'react'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RotatingLines } from 'react-loader-spinner'
import { useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import { IoClose } from "react-icons/io5";
import { removeFcmToken } from '../utils/removeFcmToken';

function Receive() {
    const [receiveData, setReceiveData] = useState([])
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const gridRef = useRef(null)
    const gridApi = useRef(null)
    const [modalIsOpen, setIsOpen] = useState(false)
    const [selectedRowCount, setSelectedRowCount] = useState(0)
    const [selectedCertificateNos, setSelectedCertificateNos] = useState([])
    const [isReceiveSaveModalOpen, setIsReceiveSaveModalOpen] = useState(false)
    const [recRemark, setRecRemark] = useState('')

    const gridStyle = useMemo(() => ({
        height: window.innerWidth >= 972 ? window.innerHeight * 0.886 : window.innerWidth >= 400 ? window.innerHeight * 0.76 : window.innerHeight * 0.78,
        width: '100%',
        marginTop: window.innerWidth <= 500 && '30px'
    }), []);

    useEffect(() => {
        const email = localStorage.getItem('USERNAME')
        const password = localStorage.getItem('PASSWORD')

        if (!email || !password) {
            navigate('/')
        }
    }, [navigate])

    useEffect(() => {
        const fetchReceiveData = async () => {
            setLoading(true)
            try {
                const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/receiveData`, {
                    method: 'POST',
                    body: JSON.stringify({
                        USERNAME: localStorage.getItem('USERNAME'),
                        PASSWORD: localStorage.getItem('PASSWORD')
                    }),
                    headers: {
                        'Content-type': 'application/json',
                    },
                })
                const data = await response.json()
                if (data?.success === true) {
                    setReceiveData(data?.data || [])
                } else {
                    toast.error(data?.message || 'Failed to fetch receive data', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                }
            } catch (error) {
                console.error('Error fetching receive data:', error)
                toast.error('Error fetching receive data', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            } finally {
                setLoading(false)
            }
        }
        fetchReceiveData()
    }, [])

    const onGridReady = (params) => {
        gridApi.current = params.api;
    };

    const onSelectionChanged = () => {
        const selectedRows = gridApi.current.getSelectedRows();
        setSelectedRowCount(selectedRows?.length || 0);

        const certificateNos = selectedRows?.map(row => row['Certificate No']);
        setSelectedCertificateNos(certificateNos || []);
    };

    const formatDateTime = (params) => {
        if (!params?.value) return '';
        try {
            const date = new Date(params.value);
            if (isNaN(date.getTime())) return params.value; // Return original if invalid date

            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${day}-${month}-${year} ${hours}:${minutes}`;
        } catch (error) {
            return params.value; // Return original value if formatting fails
        }
    };

    useEffect(() => {
        const grid = document.querySelector('.ag-root-wrapper');
        if (grid) {
            const headerCells = grid.querySelectorAll('.ag-header-cell-label');
            headerCells.forEach(cell => {
                cell.style.textAlign = 'center';
            });
        }
    }, [receiveData]);

    const [columnDefs] = useState([
        {
            checkboxSelection: true, // Enable checkbox selection
            headerCheckboxSelection: true, // Enable header checkbox selection
            headerCheckboxSelectionFilteredOnly: true, // Only show header checkbox when rows are filtered
            width: 50, // Set the width of the checkbox column
            suppressRowClickSelection: true,
        },
        {
            field: 'Certificate No',
            headerName: 'Certificate No',
            menuTabs: ['filterMenuTab'],
            filter: true,
            headerClass: "headerRenoAv",
            width: 145,
            cellStyle: { textAlign: 'center' },
            cellClass: 'excelAligmentReport',
            tooltipField: 'Certificate No',
        },
        {
            field: 'VendorID',
            headerName: 'VendorID',
            menuTabs: ['filterMenuTab'],
            filter: true,
            headerClass: "headerRenoAv",
            width: 120,
            cellStyle: { textAlign: 'center' },
            cellClass: 'excelAligment',
            tooltipField: 'VendorID',
        },
        {
            field: 'VendorName',
            headerName: 'Vendor Name',
            menuTabs: ['filterMenuTab'],
            filter: true,
            headerClass: "headerRenoAv",
            width: 150,
            cellStyle: { textAlign: 'center' },
            cellClass: 'excelAligment',
            tooltipField: 'VendorName',
        },
        {
            field: 'Shape',
            headerName: 'Shape',
            menuTabs: ['filterMenuTab'],
            width: 120,
            headerClass: "headerRenoAv",
            filter: true,
            cellClass: 'excelAligment',
            cellStyle: { textAlign: 'center' },
            tooltipField: 'Shape',
        },
        {
            field: "Size",
            headerName: "Size",
            menuTabs: ['filterMenuTab'],
            headerClass: "headerRenoAv1",
            width: 100,
            filter: true,
            cellClass: 'excelAligment',
            cellStyle: { textAlign: 'right' },
            valueFormatter: params => params?.data?.Size ? params.data.Size.toFixed(2) : '',
            tooltipField: 'Size',
        },
        {
            field: "Color",
            headerName: "Color",
            menuTabs: ['filterMenuTab'],
            headerClass: "headerRenoAv2",
            width: 100,
            filter: true,
            cellClass: 'excelAligment',
            cellStyle: { textAlign: 'center' },
            tooltipField: 'Color',
        },
        {
            field: "Clarity",
            headerName: "Clarity",
            menuTabs: ['filterMenuTab'],
            headerClass: "headerRenoAv2",
            width: 110,
            wrapText: true,
            filter: true,
            cellClass: 'excelAligment',
            cellStyle: { textAlign: 'center' },
            tooltipField: 'Clarity',
        },
        {
            field: "StaffRec",
            headerName: "Staff Rec",
            menuTabs: ['filterMenuTab'],
            headerClass: "headerRenoAv",
            width: 120,
            filter: true,
            cellClass: 'excelAligment',
            cellStyle: { textAlign: 'center' },
            tooltipField: 'Cut',
        },
        {
            field: "StaffRemark",
            headerName: "Staff Remark",
            menuTabs: ['filterMenuTab'],
            headerClass: "headerRenoAv",
            width: 150,
            filter: true,
            cellClass: 'excelAligment',
            cellStyle: { textAlign: 'center' },
            tooltipField: 'StaffRemark',
        },
        {
            field: "StaffTime",
            headerName: "Staff Time",
            menuTabs: ['filterMenuTab'],
            headerClass: "headerRenoAv",
            width: 150,
            filter: true,
            cellClass: 'excelAligment',
            cellStyle: { textAlign: 'center' },
            // valueFormatter: formatDateTime,
            tooltipField: 'StaffTime',
        },
        {
            field: "Rec",
            headerName: "Rec",
            menuTabs: ['filterMenuTab'],
            headerClass: "headerRenoAv",
            width: 85,
            filter: true,
            cellClass: 'excelAligment',
            cellStyle: { textAlign: 'center' },
            tooltipField: 'Rec',
        },
        {
            field: "RecRemark",
            headerName: "Rec Remark",
            menuTabs: ['filterMenuTab'],
            headerClass: "headerRenoAv",
            width: 150,
            filter: true,
            cellClass: 'excelAligment',
            cellStyle: { textAlign: 'center' },
            tooltipField: 'RecRemark',
        },
        {
            field: "RecTime",
            headerName: "Rec Time",
            menuTabs: ['filterMenuTab'],
            headerClass: "headerRenoAv",
            width: 150,
            filter: true,
            cellClass: 'excelAligment',
            cellStyle: { textAlign: 'center' },
            // valueFormatter: formatDateTime,
            tooltipField: 'RecTime',
        },
        {
            field: "HoldFor",
            headerName: "Hold For",
            menuTabs: ['filterMenuTab'],
            headerClass: "headerRenoAv",
            width: 120,
            filter: true,
            cellClass: 'excelAligment',
            cellStyle: { textAlign: 'center' },
            tooltipField: 'HoldFor',
        },
        {
            field: "HoldAmount",
            headerName: "Hold Amount",
            menuTabs: ['filterMenuTab'],
            headerClass: "headerRenoAv",
            width: 150,
            filter: true,
            cellClass: 'excelAligment',
            cellStyle: { textAlign: 'right' },
            tooltipField: 'HoldAmount',
        },
        {
            field: "HoldTime",
            headerName: "Hold Time",
            menuTabs: ['filterMenuTab'],
            headerClass: "headerRenoAv",
            width: 150,
            filter: true,
            cellClass: 'excelAligment',
            cellStyle: { textAlign: 'center' },
            tooltipField: 'HoldTime',
        },
    ]);

    const excelStyles = useMemo(() => {
        return [
            {
                id: 'headerRenoAv1',
                interior: {
                    color: '#C5D9F1',
                    pattern: 'Solid',
                },
                alignment: {
                    vertical: "Center",
                    horizontal: "Center",
                }
            },
            {
                id: 'headerRenoAv',
                interior: {
                    color: '#C5D9F1',
                    pattern: 'Solid',
                },
                alignment: {
                    vertical: "Center",
                    horizontal: "Center",
                }
            },
            {
                id: 'headerRenoAv2',
                interior: {
                    color: '#C5D9F1',
                    pattern: 'Solid',
                },
                alignment: {
                    vertical: "Center",
                    horizontal: "Center",
                }
            },
            {
                id: "excelAligment",
                alignment: {
                    vertical: "Center",
                    horizontal: "Center",
                },
                numberFormat: {
                    format: '#######0.00',
                },
            },
            {
                id: "excelAligmentReport",
                alignment: {
                    vertical: "Center",
                    horizontal: "Center",
                },
            },

        ];
    }, []);

    const handleLogOut = async () => {
        // await removeFcmToken()
        localStorage.removeItem('USERNAME')
        localStorage.removeItem('PASSWORD')
        localStorage.removeItem('IS_HOLD')
        localStorage.removeItem('IS_CONFIRM')
        localStorage.removeItem('IS_CLIENT_PRICE')
        localStorage.removeItem('IS_VENDOR')
        localStorage.removeItem('IS_STAFF')
        localStorage.removeItem('IS_RECEIVE')
        localStorage.removeItem('IS_EXCEL_INWARD')
        localStorage.removeItem('IS_VENDOR_NAME')
        localStorage.removeItem('IS_CLIENT_WEB')
        localStorage.removeItem('IS_SHOW_HOLD_BUTTON')
        localStorage.removeItem('IS_PRICE_EXCEL')
        localStorage.removeItem('IS_HOLD_INQURY')
        navigate('/')
    };

    function openModal() {
        setIsOpen(true);
    }
    function closeModal() {
        setIsOpen(false);
    }

    const handleReceiveSave = () => {
        if (selectedRowCount === 0) {
            toast.error('Please select Stones', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            return;
        }
        setIsReceiveSaveModalOpen(true);
    }

    const closeReceiveSaveModal = () => {
        setIsReceiveSaveModalOpen(false);
        setRecRemark('');
    }

    const handleReceiveSaveSubmit = async ({ isRemove }) => {
        if (selectedRowCount === 0) {
            toast.error('Please select Stones', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            return;
        }

        const userName = localStorage.getItem('USERNAME')
        if (userName) {
            try {
                const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/receiveSave`, {
                    method: 'POST',
                    body: JSON.stringify({
                        USERNAME: localStorage.getItem('USERNAME'),
                        PASSWORD: localStorage.getItem('PASSWORD'),
                        STONEIDLIST: selectedCertificateNos.join(', '),
                        IS_REMOVE: isRemove,
                        IS_STAFF: localStorage.getItem('IS_STAFF') == 'TRUE' ? 'yes' : 'no',
                        REMARK: recRemark,
                    }),
                    headers: {
                        'Content-type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data = await response.json();
                if (data?.message[0].IS_SUCCESS === 'TRUE') {
                    toast.success(data.message[0].MSG, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                    closeReceiveSaveModal();
                    // Refresh the data
                    const fetchResponse = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/receiveData`, {
                        method: 'POST',
                        body: JSON.stringify({
                            USERNAME: localStorage.getItem('USERNAME'),
                            PASSWORD: localStorage.getItem('PASSWORD')
                        }),
                        headers: {
                            'Content-type': 'application/json',
                        },
                    });
                    const fetchData = await fetchResponse.json();
                    if (fetchData?.success === true) {
                        setReceiveData(fetchData?.data || []);
                    }
                } else {
                    toast.error(data.message[0].MSG, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                }
            } catch (err) {
                console.error(err.message);
                toast.error(err.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            }
        }
    }
    const handleReceiveDelete = () => {
        handleReceiveSaveSubmit({ isRemove: 'yes' })
    }

    const handleCopyCertificateNo = () => {
        if (selectedRowCount === 0) {
            toast.error('Please select Stones', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            return;
        }
        const selectedRows = gridApi.current.getSelectedRows();
        const certificateNos = selectedRows?.map(row => row['Certificate No']);
        navigator.clipboard.writeText(certificateNos.join('\n'));
        toast.success('Certificate No copied to clipboard', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
        });
    }

    return (
        <>
            <ToastContainer />
            {
                loading ?
                    <div className='m-auto flex flex-row justify-center items-center' style={{ height: "100vh" }}>
                        <RotatingLines
                            visible={true}
                            height="50"
                            width="50"
                            color="grey"
                            strokeWidth="5"
                            animationDuration="0.75"
                            ariaLabel="rotating-lines-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                        />
                    </div>
                    :
                    <div className='p-2'>
                        <div class="header" style={{
                            height: window.innerWidth >= 972
                                ? window.innerHeight * 0.06
                                : window.innerHeight * 0.12
                        }}>
                            <div class="search-bar">
                                <div class="summary mt-5">
                                    <div class="summary-item">
                                        <span class='labelName'>Total: <b class='labelName' style={{ marginLeft: "5px" }}>{selectedRowCount}</b></span>
                                    </div>
                                </div>
                                <div className='button-logout lg:!hidden absolute !right-2 !top-0 !w-fit'>
                                    <button class="logout-hover" onClick={openModal}>
                                        Log Out
                                    </button>
                                </div>
                            </div>
                            <div className='button-container flex flex-row'>
                                <button onClick={() => handleReceiveSave()} class='receive-hover'>
                                    Receive Save
                                </button>
                                <button onClick={() => handleReceiveDelete()} class='receive-hover'>
                                    Receive Delete
                                </button>
                                {selectedRowCount > 0 && <button onClick={() => handleCopyCertificateNo()} class='buttonCopyDetails'>
                                    Copy CertNo
                                </button>}
                            </div>

                            <div className='button-logout !hidden lg:!block'>
                                <button class="logout-hover" onClick={openModal}>
                                    Log Out
                                </button>
                            </div>
                        </div>
                        <div id="gridTable" style={gridStyle} class="ag-theme-alpine !mt-5">
                            <AgGridReact
                                rowData={receiveData}
                                columnDefs={columnDefs}
                                ref={gridRef}
                                excelStyles={excelStyles}
                                onFirstDataRendered={onGridReady}
                                onSelectionChanged={onSelectionChanged}
                                rowSelection='multiple'
                                suppressRowClickSelection={true}
                                overlayNoRowsTemplate={loading === true ? '<div class="ag-overlay-loading-center">Loading...</div>' : '<div class="ag-overlay-loading-center">No data to show</div>'}
                            ></AgGridReact>
                        </div>

                        <Modal open={modalIsOpen} footer={null} width={305} closable={false} onCancel={closeModal} centered>
                            <label style={{ width: "100%", textAlign: "center", marginLeft: "44px" }}>Are you sure want to Logout?</label>
                            <div style={{ display: "flex", justifyContent: "center", gap: "15px", marginTop: "10px" }}>
                                <button className='hold-hover' onClick={handleLogOut}>
                                    Yes
                                </button>
                                <button className='confirm-hover' onClick={closeModal}>
                                    No
                                </button>
                            </div>
                        </Modal>

                        {/* Receive Save Modal */}
                        <Modal destroyOnClose={true} open={isReceiveSaveModalOpen} footer={null} width={400} closable={false} onCancel={closeReceiveSaveModal} centered>
                            <div style={{ display: "flex", justifyContent: "end", gap: "15px", marginTop: "10px" }}>
                                <IoClose style={{ position: "absolute", top: "10px", right: "18px" }} className='close-hover !w-8 !h-8 ' onClick={closeReceiveSaveModal} size={30} />
                            </div>
                            <div style={{ marginTop: "20px" }}>
                                <label style={{ fontWeight: "600", color: "black", fontFamily: "Poppins", marginBottom: "10px", display: "block" }}>
                                    Rec Remark:
                                </label>
                                <input
                                    type="text"
                                    placeholder="Enter Rec Remark"
                                    value={recRemark}
                                    onChange={(e) => setRecRemark(e.target.value)}
                                    style={{
                                        width: "100%",
                                        outline: "none",
                                        borderRadius: "5px",
                                        padding: "8px",
                                        border: "1px solid black",
                                        fontSize: "14px"
                                    }}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            handleReceiveSaveSubmit();
                                        }
                                    }}
                                />
                            </div>
                            <div style={{ display: "flex", justifyContent: "center", gap: "15px", marginTop: "20px" }}>
                                <button className='receive-hover' onClick={() => handleReceiveSaveSubmit({ isRemove: 'no' })}>
                                    Save
                                </button>
                            </div>
                        </Modal>
                    </div>
            }
        </>
    )
}

export default Receive